import React from "react";
import { Col, Row } from "antd";
import { LoadingSpinner, Card, AccordionV2, EmptyStateV2 } from "pepsico-ds";

// SBACCI source component. Only the SBACCI-exclusive "Reports Content"
// block is extracted here - the SBACCI filter row is shared with Woodmac
// and remains in the parent (SBACCIScreen.js). All state, selectors and
// handler logic continue to live in the parent and are passed in as props
// unchanged - this component is presentation-only.
const SbacciSource = props => {
  const {
    selectedTab,
    isSBACCIDataLoading,
    reportData,
    renderedSections,
    accordionSelectedIndex,
    renderSection,
    pdfUrl
  } = props;

  return (
    <>
      {/* Reports Content in SBACCI */}
      {selectedTab === 2 && (
        <Row justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              {isSBACCIDataLoading ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: 300
                    }}
                  >
                    <LoadingSpinner
                      size={{ height: "80px", width: "80px" }}
                    />
                  </div>
                </>
              ) : reportData?.executiveSummaryReport?.length > 0 ||
                reportData?.petMarginReport?.length > 0 ||
                reportData?.petMonthlyReport?.length > 0 ||
                reportData?.rPETMarketInsightReport?.length > 0 ||
                reportData?.rPETMonthlyEconomicReport?.length > 0 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      width: "100%", minHeight: '625px'
                    }}
                  >
                    <div className="sba-cci-reports-section">
                      <div className="sba-cci-reports-section-report-title">
                        Reports
                      </div>

                      <div className="sba-cci-reports-accordion-wrap">
                        <AccordionV2
                          className=""
                          onClickAdd={function wRe() {}}
                          onUpdate={function wRe() {}}
                          presentation="box-shadow"
                          selectedItemIndex={accordionSelectedIndex}
                          style={{ position: "relative" }}
                        >
                          {renderedSections.map(s =>
                            renderSection(reportData[s.key], s.label)
                          )}
                        </AccordionV2>
                      </div>
                    </div>

                    <div
                      className="sba-cci-pdf-section"
                      style={
                        pdfUrl == null
                          ? {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center"
                            }
                          : {}
                      }
                    >
                      {pdfUrl == null ? (
                        <>
                          <div>
                            <EmptyStateV2
                              className=""
                              description="Select a report from the left panel to preview it here."
                              icon="insert_drive_file"
                              style={{
                                minHeight: "300px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                              titleContent="Pick a report to preview"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <iframe
                            src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`}
                            width="100%"
                            height="500px"
                            style={{
                              border: "none",
                              height: "100%"
                            }}
                            title="PDF Viewer"
                            loading="eager"
                            allow="cross-origin-isolated"
                          />
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <EmptyStateV2
                    className=""
                    description="No reports available for the selected date range"
                    icon="mobiledata_off"
                    style={{
                      minHeight: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  />
                </>
              )}
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default SbacciSource;
